module.exports = __webpack_public_path__ + "media/stylesheets/images/icon/aside_coupon_pc-66fb7293f0ad1fe4f678933fc90e51ac.svg";